import api from 'api'

// Record keys are backend parameter names and are sent verbatim.
export type ExecuteHttpServiceGetParams = {
  service: string
  factoryArgs: Record<string, string>
  urlPattern: string
  urlPatternParams: Record<string, string>
  queryParams: Record<string, string>
  graphqlQuery?: string
  graphqlVariables?: Record<string, unknown>
}

export type ExecuteHttpServiceGetResponse = {
  url: string
  statusCode: number
  elapsedMs: number
  headers: Record<string, string>
  body: unknown
}

export const executeHttpServiceGet = async (
  params: ExecuteHttpServiceGetParams
): Promise<ExecuteHttpServiceGetResponse> => {
  const result = await api.post<ExecuteHttpServiceGetResponse>(
    '/admin/http_services/get',
    params
  )
  return result.data
}
